// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";



/* const firebaseConfig = {
  apiKey: "AIzaSyBxifV4ZUCFS6nnQkz8tkNOa5fF7SMkyWo",
  authDomain: "ndl-0101.firebaseapp.com",
  projectId: "ndl-0101",
  storageBucket: "ndl-0101.firebasestorage.app",
  messagingSenderId: "536675847830",
  appId: "1:536675847830:web:5b972f1073f3810fa33cb7",
  measurementId: "G-GW271CGKQQ"
};  */


 const firebaseConfig = {
  apiKey: "AIzaSyCookAPoPSf75Gt4kYcm71rV22VYBOh9DU",
  authDomain: "ndl-app-5680c.firebaseapp.com",
  projectId: "ndl-app-5680c",
  storageBucket: "ndl-app-5680c.firebasestorage.app",
  messagingSenderId: "733535024625",
  appId: "1:733535024625:web:be02efde4834b1fdfd4050",
  measurementId: "G-8SVZJ7XGZP"
}; 


const app = initializeApp(firebaseConfig);
export const auth = getAuth(app)
export default app